import { gql } from "@apollo/client";

export const GET_CURRENT_HEATS_CONFIG = gql`
    query getCurrentHeatsConfig($id: ID!) {
        event(id: $id) {
            id
            currentHeats {
                id
                config {
                    calculator
                    categories
                    categoryGroups
                    isTeams
                    hasStartlist
                    runBased
                }
            }
        }
    }
`;
